module.exports = __webpack_public_path__ + "static/media/seasonal_page_Q2_2026_inner_glow_btn.60aedb41.png";